import React from 'react';
import { useIsMediaLibrary } from 'hooks/use-is-media-library';

interface FileViewRendererProps {
  viewMode: 'grid' | 'list';
  GridComponent: React.ComponentType<any>;
  ListComponent: React.ComponentType<any>;
  commonViewProps: any;
}

export const FileViewRenderer: React.FC<FileViewRendererProps> = ({
  viewMode,
  GridComponent,
  ListComponent,
  commonViewProps,
}) => {
  const isMediaLibrary = useIsMediaLibrary();

  return (
    <div className={isMediaLibrary ? 'w-full' : 'min-h-0 h-full flex-1 overflow-hidden'}>
      {viewMode === 'grid' ? (
        <GridComponent {...commonViewProps} />
      ) : (
        <ListComponent {...commonViewProps} />
      )}
    </div>
  );
};
